import { render } from "./message-bubble.vue?vue&type=template&id=f196549e&scoped=true&ts=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"

import "./message-bubble.vue?vue&type=style&index=0&id=f196549e&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f196549e"]])

export default __exports__